export default __webpack_public_path__ + "static/media/el23.d99b102c.svg";